import * as React from 'react';

const H5ChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 20v-6h7v6h2V6h-2v6H5V6H3v14h2zM18.4 11.1c1.6 0 2.6-1 2.6-2.4 0-1.3-.7-2.2-2.2-2.2-.7 0-1.1.2-1.3.4l.1-1.5h2.8l.1-1.1h-4l-.3 3.6.9.3c.3-.4.8-.6 1.2-.6.8 0 1.2.4 1.2 1.2 0 .7-.4 1.2-1.3 1.2-.6 0-1.2-.3-1.7-.7l-.7 1c.7.5 1.5.8 2.6.8z"
        />
    </svg>
);

H5ChunkySvg.displayName = 'H5ChunkySvg';
export default H5ChunkySvg;
